import React from "react";
import { motion, useReducedMotion, type Variants } from "framer-motion";
import { DISPLAY_HEADING } from "../utils/typography";
import { NudgeArrow } from "./NudgeArrow";
type SectionHeadingProps = {
  id: string;
  title: string;
  as?: "h1" | "h2";
};
const ease = [0.23, 1, 0.32, 1] as const;
const STAGGER = 0.04;
const wordVariants: Variants = {
  hidden: {},
  shown: {
    transition: {
      staggerChildren: STAGGER
    }
  }
};
const letterVariants: Variants = {
  hidden: {
    y: "105%"
  },
  shown: {
    y: "0%",
    transition: {
      duration: 0.3,
      ease
    }
  }
};
export function SectionHeading({
  id,
  title,
  as: Tag = "h2"
}: SectionHeadingProps) {
  const reduce = useReducedMotion();
  // Arrow lands just after the last letter settles
  const afterTitle = title.length * STAGGER + 0.1;
  return <motion.div className="flex flex-row-reverse items-start justify-end gap-4 md:gap-[2vw]" initial={reduce ? false : "hidden"} whileInView="shown" viewport={{
    once: true,
    amount: 0.4
  }} data-id="element-297" data-mp="ujhiy6aw8e0f">
      <Tag id={id} aria-label={title} className={`min-w-0 ${DISPLAY_HEADING} text-espresso`} data-id="element-298" data-mp="1t95wh4lfa96o">
        {/* Words wrap as units on narrow screens; each clips its own letters as they rise */}
        <motion.span aria-hidden="true" variants={wordVariants} className="block" data-id="element-299" data-mp="230aao239xq0g">
          {title.split(" ").map((word, w, words) => <React.Fragment key={`${word}-${w}`} data-id="element-300" data-mp="1y7r0zg7pjf0x" data-mpi={w}>
              <span className="-my-[0.06em] inline-block overflow-hidden whitespace-nowrap py-[0.06em] align-bottom" data-id="element-301" data-mp="2bzxgd031dhzb">
                {word.split("").map((char, i) => <motion.span key={`${char}-${i}`} variants={letterVariants} className="inline-block" data-id="element-302" data-mp="273q6wxbflocm" data-mpi={i}>
                    {char}
                  </motion.span>)}
              </span>
              {w < words.length - 1 && " "}
            </React.Fragment>)}
        </motion.span>
      </Tag>

      <div className="flex shrink-0 flex-col items-start justify-end self-stretch pt-[1vw]" data-id="element-303" data-mp="mlsdbr615g3p">

        <motion.span aria-hidden="true" className="block" variants={{
        hidden: {
          opacity: 0,
          x: -12,
          y: -12
        },
        shown: {
          opacity: 1,
          x: 0,
          y: 0,
          transition: {
            duration: 0.3,
            ease,
            delay: afterTitle + 0.08
          }
        }
      }} data-id="element-304" data-mp="1c9xrak8isofd">
          <NudgeArrow delay={afterTitle + 0.5} data-id="element-305" data-mp="1qb0fb2j2s8sx" />
        </motion.span>
      </div>
    </motion.div>;
}